import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Field } from "react-final-form";
import MetaError from "../MetaError";
import { styles } from "./_base.styles";
import { CheckListInput } from "../../inputs";

function CheckListField({ classes, id, label, options, disabled, onAddElement }) {
  const onChangeHandler = (v, input) => {
    if (v && v.length > 0) {
      onAddElement && onAddElement();
    }
    input.onChange && input.onChange(v);
  };
  return (
    <div className={classes.root}>
      <Field name={id}>
        {({ input, meta }) => (
          <>
            <CheckListInput
              className={classes.input}
              label={label}
              value={input.value}
              onChange={(value) => onChangeHandler(value, input)}
              options={options}
              disabled={disabled}
            />
            <div className={"FormFieldError " + classes.error}>
              <MetaError meta={meta} />
            </div>
          </>
        )}
      </Field>
    </div>
  );
}

export default withStyles(styles)(CheckListField);
